import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { getHttpHeaders } from '@commons/utility/util';

import { environment } from '@environments/environment';

import { CustomResponseDto } from '@core/model/custom-response-dto';

@Injectable()
export class EmailVerificationService {
  private apiGatewayUrl = environment.apiGatewayUrl;
  private checkExistsByEmailUrl = `${this.apiGatewayUrl}onboarding-service/public/originations/check-exists/email/{email}`;

  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  public accountExistsByEmail(email: string): Observable<CustomResponseDto<boolean>> {
    return this.http.get<CustomResponseDto<boolean>>(this.checkExistsByEmailUrl.replace('{email}', email), {
      headers: this.headers,
    });
  }
}
